import { freeze as t } from "./ghl-ui.es1554.js";
var s = function() {
  function e(i, r) {
    this.inlineSize = i, this.blockSize = r, t(this);
  }
  return e;
}();
export {
  s as ResizeObserverSize
};
